import { render, staticRenderFns } from "./WorkAreaSection.vue?vue&type=template&id=54c092a0"
import script from "./WorkAreaSection.vue?vue&type=script&lang=js"
export * from "./WorkAreaSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports